export const GET_STUDENT_PROFILE = "GET_STUDENT_PROFILE";
export const GET_COURSE_OFFERING = "GET_COURSE_OFFERING";
